export default __webpack_public_path__ + "static/media/holistic-health.6b72f0cc.png";